'use strict';

var $ = require('jquery');
var _ = require('lodash');

// todo: don't use $ for forEach

var SearchCriteriaBuilderFactory = function SearchCriteriaBuilderFactory() {
  // todo: use lodash instead
  var ObjectUtils = {
    /**
     * Return the first element that has property 'prop' with the given value.
     *
     * @return property name or null when not found
     */
    search: function search(array, prop, value) {
      for (var i = 0, len = array.length; i < len; i++) {
        if (array[i][prop] === value) {
          return array[i];
        }
      }
      return null;
    },
    /**
     * Return all elements that have property 'prop' with the given value.
     *
     * @return list of elements (possibly empty)
     */
    findAll: function findAll(array, prop, value) {
      var result = [];
      for (var i = 0, len = array.length; i < len; i++) {
        if (array[i][prop] === value) {
          result.push(array[i]);
        }
      }
      return result;
    },
    /**
     * Return the first element that has property 'id' with the given value.
     *
     * @return property name or null when not found
     */
    searchById: function searchById(array, index) {
      return this.search(array, 'id', parseInt(index));
    },
    /**
     * Return the first element that has property 'index' with the given value.
     *
     * @return property name or null when not found
     */
    searchByIndex: function searchByIndex(array, index) {
      return this.search(array, 'index', parseInt(index));
    }
  };
  var SearchCriteriaBuilder = function SearchCriteriaBuilder(appliedFilters) {
    this.fields = appliedFilters;
    this.logicOperators = [{
      value: 'AND'
    }, {
      value: 'OR'
    }];
    this.source = {
      dataType: 'json',
      dataFields: [{
        name: 'logicOperator',
        type: 'string'
      }, {
        name: 'id',
        type: 'number'
      }, {
        name: 'index',
        type: 'number'
      }, {
        name: 'name',
        type: 'string'
      }, {
        name: 'parentIndex',
        type: 'number'
      }, {
        name: 'filterOperator',
        type: 'string'
      }, {
        name: 'inputFilter',
        type: 'string'
      }],
      hierarchy: {
        keyDataField: {
          name: 'index'
        },
        parentDataField: {
          name: 'parentIndex'
        }
      },
      id: 'id',
      localData: this.fields
    };
    this.getFirstAvailableIndex = function () {
      return Math.max.apply(null, this.fields.map(function (field) {
        return field.id;
      })) + 1;
    };
    this.lastId = appliedFilters.length > 0 ? this.getFirstAvailableIndex() : 0;

    /**
     * Appends a new field to the top group.
     *
     * @param field {Object} a field
     */
    this.appendField = function (field) {
      // choose the first operator as the default one:
      field.filterOperator = field.availableFilters[0].id;
      this.fields.push(field);

      // make it child of the top level element:
      if (this.fields.length === 1) {
        field.parentIndex = null;
      } else if (this.fields.length === 2) {
        field.parentIndex = null;
        this.createGroup(_.cloneDeep(this.fields));
      } else {
        field.parentIndex = this.fields[0].index;
      }
    };
    this.searchByIndex = function (index) {
      return ObjectUtils.searchByIndex(this.fields, index);
    };
    this.searchById = function (id) {
      return ObjectUtils.searchById(this.fields, id);
    };

    /**
     * Remove from fields table the field with given index.
     *
     * @param index {Number} fields's index
     * @return removed element or null
     */
    this.removeByIndex = function (index) {
      var field = this.searchByIndex(index);
      var arrayIndex = this.fields.indexOf(field);
      if (arrayIndex >= 0) {
        this.fields.splice(arrayIndex, 1);
      }
      return field;
    };

    /**
     * Return indexes of all parents in given list of fields.
     * Root of all nodes (null) is excluded
     *
     * @param selection {Array} list of fields
     * @return set of parents' indexes, except null
     */
    this.getParentIndexes = function (selection) {
      var parentIndexes = [];
      selection.forEach(function (row) {
        // ignore tree root:
        if (row.parentIndex !== null) {
          parentIndexes.push(row.parentIndex);
        }
      });
      return _.uniq(parentIndexes);
    };
    this.findChildren = function (parentIndex) {
      return ObjectUtils.findAll(this.fields, 'parentIndex', parentIndex);
    };
    this.isFieldRow = function (index) {
      return this.searchById(index).availableFilters;
    };
    this.isDateRow = function (index) {
      return this.isFieldRow(index) && this.searchById(index).type === 'DATETIME';
    };
    this.shiftFieldsRight = function (selection) {
      var minSelectedIndex = Math.min.apply(null, selection.map(function (field) {
        return field.index;
      }));

      // In GUI they are different JavaScript objects (sic!) than builder.fields,
      // so haven't been changed when making space for the new parent.
      var adjustIdsInSelection = function adjustIdsInSelection() {
        $.each(selection, function (i, row) {
          row.index++;
        });
      };
      this.shiftFields(minSelectedIndex, 1);
      adjustIdsInSelection();
      return minSelectedIndex;
    };
    this.shiftFieldsLeft = function (firstSelectedId, step) {
      this.shiftFields(firstSelectedId, -step);
    };
    this.shiftFields = function (firstSelectedIndex, step) {
      // All indexes >= the first given index are increased to make space for the new parent.
      // It turns: [1, _2_, 3] into [1, 3, 4]
      var incIndexes = function incIndexes(field) {
        if (field.index >= firstSelectedIndex) {
          field.index += step;
        }
      };

      // All indexes >= the first given index have been increased, so their parents need
      // to be adjusted too:
      var incParentIndexes = function incParentIndexes(field) {
        if (field.parentIndex >= firstSelectedIndex) {
          field.parentIndex += step;
          // If parentIndex after calculations < 0 then node is in top level, so parentIndex should be null
          if (field.parentIndex < 0) {
            field.parentIndex = null;
          }
        }
      };
      var makeSpaceForNewField = function makeSpaceForNewField(builder) {
        $.each(builder.fields, function (i, row) {
          incIndexes(row);
          incParentIndexes(row);
        });
      };
      makeSpaceForNewField(this);
    };
    this.insertField = function (beforeIndex, field) {
      var startIndex = this.fields.indexOf(this.searchByIndex(beforeIndex));
      this.fields.splice(startIndex, 0, field);
    };
    this.setParent = function (childIndex, parentIndex) {
      this.searchByIndex(childIndex).parentIndex = parentIndex;
    };
    this.insertParent = function (selection, parent) {
      var minIndex = Math.min.apply(null, selection.map(function (field) {
        return field.index;
      }));
      this.insertField(minIndex, parent);
      for (var i = 0; i < selection.length; i++) {
        this.setParent(selection[i].index, parent.index);
      }
    };
    this.createGroup = function (selection) {
      // sort group of selection's parent
      var parentIndex = this.searchByIndex(selection[0].index).parentIndex;
      var children = this.findChildren(parentIndex);

      // group dispersed fields together (eg. [1, 4, 5] -> [1, 2, 3])
      var minIndex = Math.min.apply(null, selection.map(function (field) {
        return field.index;
      }));
      var startIndex = children.indexOf(this.searchByIndex(minIndex));
      var moved = 0;
      for (var i = 1; i < selection.length; ++i) {
        var nextSelected = this.searchByIndex(selection[i].index);
        var nextIndex = children.indexOf(nextSelected);
        while (++startIndex < nextIndex) {
          this.moveUp([nextSelected]);
          moved++;
        }
        startIndex -= moved;
        moved = 0;
        // selection is now also ordered:
        selection[i].index = nextSelected.index;
      }

      // insert the new parent:
      parentIndex = this.shiftFieldsRight(selection);
      var parent = {
        id: this.getNextAvailableId(),
        index: parseInt(parentIndex),
        parentIndex: selection[0].parentIndex,
        name: 'AND'
      };
      this.insertParent(selection, parent);
    };
    this.getNextAvailableId = function () {
      return this.lastId++;
    };
    this.isGroupingDisabled = function (selection) {
      var isWholeGroupSelected = function isWholeGroupSelected(builder, parentIndex) {
        return builder.findChildren(parentIndex).length === selection.length;
      };
      var isNotRoot = function isNotRoot(parentIndex) {
        return parentIndex !== null;
      };
      var checkIfSelectedHaveTheSameParent = function checkIfSelectedHaveTheSameParent() {
        var info = {
          hasSameParent: true,
          parentIndex: ''
        };
        $.each(selection, function (i, row) {
          if (info.parentIndex === '') {
            info.parentIndex = row.parentIndex;
          } else {
            if (row.parentIndex !== info.parentIndex) {
              info.hasSameParent = false;
            }
          }
        });
        return info;
      };
      var checkIfWholeGroupIsSelected = function checkIfWholeGroupIsSelected(builder, hasSameParent, parentIndex) {
        return hasSameParent && isNotRoot(parentIndex) && isWholeGroupSelected(builder, parentIndex);
      };
      var disableGroupButton = function disableGroupButton(builder) {
        var groupButtonDisabled = true;
        if (selection.length > 1) {
          var sameParentInfo = checkIfSelectedHaveTheSameParent();
          var wholeGroupSelected = checkIfWholeGroupIsSelected(builder, sameParentInfo.hasSameParent, sameParentInfo.parentIndex);
          if (sameParentInfo.hasSameParent && !wholeGroupSelected) {
            groupButtonDisabled = false;
          }
        }
        return groupButtonDisabled;
      };
      return disableGroupButton(this);
    };
    this.notOneFieldSelected = function (selection) {
      return selection.length !== 1;
    };
    this.selectedTopmostElement = function (selection) {
      return selection[0].parentIndex === null;
    };
    this.isUngroupingDisabled = function (selection) {
      var isOperatorSelected = function isOperatorSelected() {
        return selection[0].filterOperator === undefined;
      };
      var nothingToUngroup = function nothingToUngroup(builder) {
        return builder.fields.length < 2;
      };
      var willCreateOrphans = function willCreateOrphans(builder) {
        return builder.searchByIndex(parseInt(selection[0].parentIndex)).parentIndex === null;
      };
      if (this.notOneFieldSelected(selection) || nothingToUngroup(this)) {
        return true;
      }
      if (this.selectedTopmostElement(selection) || isOperatorSelected() || willCreateOrphans(this)) {
        return true;
      }
      return false;
    };
    this.isMoveUpDisabled = function (selection) {
      var isFirstInGroup = function isFirstInGroup(builder) {
        var selected = selection[0];
        var children = builder.findChildren(parseInt(selected.parentIndex));
        var min = Math.min.apply(null, children.map(function (field) {
          return field.index;
        }));
        return min === parseInt(selected.index);
      };
      if (this.notOneFieldSelected(selection) || this.selectedTopmostElement(selection)) {
        return true;
      }
      if (isFirstInGroup(this)) {
        return true;
      }
      return false;
    };
    this.isMoveDownDisabled = function (selection) {
      var isLastInGroup = function isLastInGroup(builder) {
        var selected = selection[0];
        var children = builder.findChildren(parseInt(selected.parentIndex));
        var max = Math.max.apply(null, children.map(function (field) {
          return field.index;
        }));
        return max === parseInt(selected.index);
      };
      if (this.notOneFieldSelected(selection) || this.selectedTopmostElement(selection)) {
        return true;
      }
      if (isLastInGroup(this)) {
        return true;
      }
      return false;
    };
    this.isDeleteDisabled = function (selection) {
      var numberOfNotSelectedInGroup = function numberOfNotSelectedInGroup(builder, index) {
        return builder.findChildren(index).length - ObjectUtils.findAll(selection, 'parentIndex', index).length;
      };
      var produceInvalidGroup = function produceInvalidGroup(builder) {
        var invalidGroup = false;
        var parentIndexes = builder.getParentIndexes(selection);
        parentIndexes.forEach(function (parentIndex) {
          if (numberOfNotSelectedInGroup(builder, parseInt(parentIndex)) < 1) {
            invalidGroup = true;
          }
        });
        return invalidGroup;
      };
      var disableDeleteButton = false;
      if (selection.length > 0) {
        disableDeleteButton = produceInvalidGroup(this);
      } else {
        disableDeleteButton = true;
      }
      return disableDeleteButton;
    };
    this.ungroup = function (selection) {
      var oldParentIndex = parseInt(selection[0].parentIndex);
      var oldParent = this.searchByIndex(oldParentIndex);
      var newParentIndex = oldParent.parentIndex;

      // pin children to grandparent:
      $.each(this.fields, function (i, field) {
        if (field.parentIndex === oldParentIndex) {
          field.parentIndex = newParentIndex;
        }
      });
      this.removeByIndex(oldParentIndex);
      this.shiftFieldsLeft(oldParentIndex, 1);
    };
    this.moveUp = function (selection) {
      var selected = selection[0];
      var siblings = this.findChildren(parseInt(selected.parentIndex));
      var prevSiblingIndex = Math.max.apply(null, siblings.map(function (field) {
        return field.index < selected.index ? field.index : -1;
      }));
      this.swapElements(prevSiblingIndex, parseInt(selected.index));
    };
    this.moveDown = function (selection) {
      var selected = selection[0];
      var siblings = this.findChildren(parseInt(selected.parentIndex));
      var nextSiblingIndex = Math.min.apply(null, siblings.map(function (field) {
        return field.index > selected.index ? field.index : Number.MAX_VALUE;
      }));
      this.swapElements(parseInt(selected.index), nextSiblingIndex);
    };
    this.getSubtree = function (rootIndex) {
      var _getSubtree = function getSubtree(builder, parentIndex) {
        var subtree = [builder.searchByIndex(parentIndex)];
        var children = builder.findChildren(parentIndex);
        $.each(children, function (i, child) {
          var descendants = _getSubtree(builder, child.index);
          subtree = subtree.concat(descendants);
        });
        return subtree;
      };
      return _getSubtree(this, rootIndex);
    };
    this.cutSubtree = function (rootIndex) {
      var subtree = this.getSubtree(rootIndex);
      var index = this.fields.indexOf(this.searchByIndex(rootIndex));
      var builder = this;
      $.each(subtree, function (i, element) {
        builder.removeByIndex(element.index);
      });
      return {
        subtree: subtree,
        index: index
      };
    };
    this.pasteSubtree = function (subtree, index) {
      var builder = this;
      $.each(subtree, function (i, element) {
        builder.fields.splice(index + i, 0, element);
      });
    };
    this.incIndexesBy = function (subtree, incStep) {
      $.each(subtree, function (i, element) {
        if (i !== 0) {
          element.parentIndex += incStep;
        }
        element.index += incStep;
      });
    };
    this.decIndexesBy = function (subtree, decStep) {
      $.each(subtree, function (i, element) {
        if (i !== 0) {
          element.parentIndex -= decStep;
        }
        element.index -= decStep;
      });
    };
    this.swapElements = function (firstIndex, secondIndex) {
      var calculateInsertIndex = function calculateInsertIndex() {
        return firstSubtreeInfo.index + secondSubtree.length;
      };
      var firstSubtreeInfo = this.cutSubtree(firstIndex);
      var firstSubtree = firstSubtreeInfo.subtree;
      var secondSubtree = this.getSubtree(secondIndex);
      this.incIndexesBy(firstSubtree, secondSubtree.length);
      this.decIndexesBy(secondSubtree, firstSubtree.length);
      this.pasteSubtree(firstSubtree, calculateInsertIndex());
    };
    this.deleteRows = function (rows) {
      var deleteSelection = function deleteSelection(builder, selection) {
        var nodesWhichParentIsNotSelected = function nodesWhichParentIsNotSelected(selected) {
          return !_.includes(_.map(selection, function (element) {
            return element.index;
          }), selected.parentIndex);
        };
        var nodesToDelete = _.filter(selection, nodesWhichParentIsNotSelected);
        for (var i = nodesToDelete.length - 1; 0 <= i; --i) {
          var cut = builder.cutSubtree(parseInt(nodesToDelete[i].index));
          builder.shiftFieldsLeft(parseInt(nodesToDelete[i].index), cut.subtree.length);
        }
      };
      var ungroupSingles = function ungroupSingles(builder) {
        var parents = builder.getParentIndexes(builder.fields);
        parents.forEach(function (index) {
          var children = builder.findChildren(index);
          if (children.length === 1) {
            builder.ungroup(children);
          }
        });
      };
      deleteSelection(this, rows);
      ungroupSingles(this);
    };
    this.assertContinuousIndexes = function () {
      if (this.fields.length > 0) {
        var assert = function assert(condition, message) {
          if (!condition) {
            message = message || 'Assertion failed';
            if (typeof Error !== 'undefined') {
              throw new Error(message);
            }
            throw message; // Fallback
          }
        };
        var start = this.fields[0].index;
        for (var i = 0; i < this.fields.length; i++) {
          assert(this.fields[i].index >= 0, 'Negative id ');
          assert(start + i === this.fields[i].index, 'Wrong id ' + this.fields[i].index);
          var children = this.findChildren(i);
          assert(children.length === 0 || children.length > 1, 'Group with single node ' + this.fields[i].index);
        }
      }
    };
    this.getFilledFilterInputIds = function () {
      return _.map(_.filter(this.fields, function (field) {
        return field.inputFilter;
      }), function (field) {
        return field.id;
      });
    };
    this.ignoreValidation = function (id) {
      this.searchById(id).ignoreValidation = true;
    };
    this.unignoreValidation = function (id) {
      this.searchById(id).ignoreValidation = false;
    };
  };
  return SearchCriteriaBuilder;
};
SearchCriteriaBuilderFactory.$inject = [];
module.exports = SearchCriteriaBuilderFactory;